/* Start: Urgent / Rush Fee Logic */
(() => {
  const root = window.Shopify?.routes?.root || '/';

  const postJSON = async (path, payload) => {
    const res = await fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    return res.json();
  };

  const getCart = async () => {
    const res = await fetch(root + 'cart.js', { method: 'GET' });
    return res.json();
  };

  const formatBtn = (btn, isOn, priceLabel) => {
    btn.dataset.urgentOn = isOn ? '1' : '0';
    btn.textContent = isOn ? `Urgent Added (${priceLabel})` : `Add Urgent (${priceLabel})`;
    btn.classList.toggle('is-on', isOn);
  };

  const init = async (wrap) => {
    const rushVariantId = Number(wrap.dataset.rushVariantId || 0);
    const priceLabel = wrap.dataset.rushFeePriceLabel || '+ Rush fee';

    if (!rushVariantId) return;

    const btn = wrap.querySelector('[data-urgent-toggle]');
    if (!btn) return;

    // Sync initial state
    let cart = await getCart();
    let rushLine = cart.items.find((i) => Number(i.id) === rushVariantId);

    // If cart has ONLY the rush fee, remove it automatically
    const nonRushCount = cart.items.filter((i) => Number(i.id) !== rushVariantId).length;
    if (rushLine && nonRushCount === 0) {
      await postJSON('cart/change.js', { id: rushLine.key, quantity: 0 });
      window.location.reload();
      return;
    }

    formatBtn(btn, !!rushLine, priceLabel);

    btn.addEventListener('click', async () => {
      btn.disabled = true;

      try {
        cart = await getCart();
        rushLine = cart.items.find((i) => Number(i.id) === rushVariantId);

        const hasNonRush = cart.items.some((i) => Number(i.id) !== rushVariantId);
        if (!hasNonRush && !rushLine) {
          // Nothing to rush if cart is empty (or only rush fee)
          btn.disabled = false;
          return;
        }

        if (!rushLine) {
          // Add rush fee line item
          await postJSON('cart/add.js', {
            items: [
              {
                id: rushVariantId,
                quantity: 1,
                properties: {
                  'Type': 'Urgent / Rush processing'
                }
              }
            ],
          });

          // Optional: also store a cart attribute for visibility in admin
          await postJSON('cart/update.js', {
            attributes: { 'Urgent order': 'Yes' },
          });
        } else {
          // Remove rush fee line item
          await postJSON('cart/change.js', { id: rushLine.key, quantity: 0 });

          await postJSON('cart/update.js', {
            attributes: { 'Urgent order': '' },
          });
        }

        // Simplest reliable refresh (works for cart page + drawer)
        window.location.reload();
      } catch (e) {
        console.error('[Urgent Fee] Error:', e);
        btn.disabled = false;
      }
    });
  };

  document.addEventListener('DOMContentLoaded', async () => {
    const blocks = document.querySelectorAll('[data-urgent-fee]');
    for (const wrap of blocks) await init(wrap);
  });
})();
 /* End: Urgent / Rush Fee Logic */
